import * as THREE from "three";
import µ from "../../earth/1.0.0/micro";

export default (function (scene, radius) {
    const SEGMENTS = 60; // number of vertices. Higher = better mouse accuracy, slower loading
    var group;

    function meshTextMaterial(textInfo, font){
        let textGeometry = new THREE.TextBufferGeometry(textInfo.text, {
            font: font,
            size: µ.isMobile() ? 4 : 8,
            height: 2,
            curveSegments: 4,
            bevelEnabled: false
        });

        textGeometry.computeBoundingBox();

        let centerOffsetX = textInfo.centerOffset[0] * (textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x);
        let centerOffsetY = textInfo.centerOffset[1] * (textGeometry.boundingBox.max.y - textGeometry.boundingBox.min.y);

        let textMaterial = new THREE.MeshBasicMaterial({
            color: textInfo.color,
            transparent: false,
            wireframe: false,
            opacity: 1.0,
        });

        let textMesh = new THREE.Mesh(textGeometry, textMaterial);
        textMesh.position.x = textInfo.position[0] + centerOffsetX;
        textMesh.position.y = textInfo.position[1] + centerOffsetY;
        textMesh.position.z = textInfo.position[2];
        textMesh.rotation.x = 0;
        textMesh.rotation.y = 0;

        return textMesh;
    }

    function clear(){
        if(group && group.children && group.children.length > 0){
            while(group.children.length > 0){
                if(group.children[0].geometry){
                    group.children[0].geometry.dispose();
                    group.children[0].geometry = undefined;
                }
                if(group.children[0].material){
                    group.children[0].material.dispose();
                    group.children[0].material = undefined;
                }
                group.remove(group.children[0]);
            }
        }

        group = undefined;
    }

    function rendered(){
        return group !== undefined;
    }

    function render(textInfos, quickRender){
        // points are values converted with projection
        // textInfo = {text: "1000hPa", position: [x, y, z]} ,

        let loader = new THREE.FontLoader();
        loader.load('/styles/helvetiker_regular.typeface.json', function (font) {
            // clear();
            group = new THREE.Group();
            textInfos.forEach(function(textInfo){
                group.add(meshTextMaterial(textInfo, font));
            });
            scene.add(group);
            quickRender();
        } );

    }

    return {
        rendered: rendered,
        render: render,
        clear: clear,
    };
});